import { httpMgr } from '../../common/network/httpMgr';
import { ApiEnums } from '../../constants/apiConstants';
import {
  BikeCardReqParams,
  BikeOrderRes,
  BuyBikeCardReqParams,
  PkgData,
} from '../../constants/bike';
import { getH5PayInst, H5PayError } from './pay';
import { isWeixin } from '../../common/env/env';
import logger from '../../common/utils/logger';

export async function fetchBikeCardList(data: BikeCardReqParams): Promise<PkgData | null> {
  if (process.env.NODE_ENV === 'development') {
    data.platform = 10;
    data.cityCode = '0571';
    data.adCode = '330016';
  }
  const res = await httpMgr.request(ApiEnums.FETCH_BIKE_CARD_LIST, data);
  return res.data;
}

export async function reqBuyBikeCard(data: BuyBikeCardReqParams): Promise<BikeOrderRes | null> {
  const res = await httpMgr.request(ApiEnums.BUY_BIKE_CARD, data);
  return res.data;
}

export async function bizSceneCheck(data: any): Promise<any | null> {
  const res = await httpMgr.request(ApiEnums.BIZ_SCENE_CHECK, data);
  return res.data;
}

/** 请求支付两轮骑行卡订单 */
export const reqOrderPay = async (data: Pick<BikeOrderRes, 'businessType' | 'businessScene' | 'orderGoPayList' | 'wechatSignTempId'> & {
  returnUrl: string;
  /** 包月 */
  monthlySub: boolean;
}) => {
  const {
    businessType,
    businessScene,
    returnUrl,
    orderGoPayList,
    monthlySub,
    wechatSignTempId,
  } = data;
  logger('reqOrderPay-returnUrl', data.returnUrl);
  const h5Pay = getH5PayInst();
  // * 对h5Pay.pay的错误处理进行封装
  return new Promise<void>(async (resolve, reject) => {
    /** 统一处理错误信息 */
    const handlePayError = (rawPayErr: H5PayError) => {
      const { code } = rawPayErr;

      if (rawPayErr.code === '2002') {
        reject(new H5PayError('取消支付', code));
      } else {
        reject(rawPayErr);
      }
    };

    try {
      if (monthlySub) {
        const {
          payNo,
          orderNo,
          payPrice,
        } = orderGoPayList[0];
        const payWithSignParams = {
          guid: payNo,
          orderId: orderNo,
          amount: payPrice,
          businessType,
          creditModel: 'normal',
          signChannel: 'alipay',
          actionOrigin: 'CardCouponsMallPage',
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          orders: orderGoPayList.map((order) => ({
            guid: order.payNo,
            orderId: order.orderNo,
            amount: order.payPrice,
          })),
          extension: {},
        };

        if (isWeixin) {
          payWithSignParams.extension = {
            contractDisplayAccount: window.$$user?.mobile || `骑行侠${+new Date()}`,
            planId: wechatSignTempId,
          };
          console.log('payWithSignParams', payWithSignParams);
          payWithSignParams.signChannel = 'wechatTrust';
        }
        await h5Pay.payWithSign(payWithSignParams);
      } else {
        logger('reqOrderPay-普通支付-returnUrl', returnUrl);
        await h5Pay.pay({
          payParams: {
            businessType,
            businessScene,
            payList: orderGoPayList.map(({
              orderNo,
              payNo,
              payPrice,
            }) => ({
              guid: payNo,
              orderId: orderNo,
              amount: payPrice,
              type: '1',
            })),
            recommomdSign: true,
            failCb: (err: H5PayError) => {
              handlePayError(err);
            },
          },
          returnUrl,
          // ! 在h5浏览器等不支持promise的环境中，promise的状态不会发生流转
          isNeedCancelCall: true,
        });
      }

      resolve();
    } catch (err) {
      handlePayError(err as H5PayError);
    }
  });
};

/** 两轮领取一亿壕补优惠券 */
export const getEverydayCoupons = async (data: any) => {
  const res = await httpMgr.request(ApiEnums.TWO_WHEEL_GET_ONE_BILLION_DISCOUNT_COUPON, data);
  return res.data;
};
